import PropTypes from 'prop-types';
import productShape from './product';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.shape(productShape))
  })
);



// WEBPACK FOOTER //
// ./src/model/Types/productLine.js